import { useState, useEffect } from 'react';

function useToggle(initialValue) {
  var _a = useState(initialValue),
      state = _a[0],
      setState = _a[1];

  useEffect(function () {
    setState(initialValue);
  }, [initialValue]);
  return [state, function toggle() {
    setState(function (state) {
      return !state;
    });
  }];
}

export { useToggle };